import * as React from "react";
import { StyleProp, StyleSheet, ViewStyle } from "react-native";
import _ from "lodash";

import { Video, Family } from "../../types";

import { View, Text } from "../../components/Themed";
import commonStyles from "../../styles/common";
import useUpdateVideo from "../../hooks/videos/useUpdateVideo";

import VideoListItem, { VideoListItemProps } from "./VideoListItem";

export interface VideoListProps {
  style?: StyleProp<ViewStyle>;
  videos?: Video[];
  family?: Family;
  renderItem?: (props: VideoListItemProps) => JSX.Element;
  disabled?: boolean;
}

function VideoList({
  style,
  videos,
  renderItem: Item = VideoListItem,
  disabled,
}: VideoListProps) {
  const { mutateAsync: updateVideo } = useUpdateVideo();
  const empty = !videos?.length;

  return (
    <View style={[style, commonStyles.grid]}>
      {videos?.map((video, index) => (
        <React.Fragment key={video.id}>
          <Item
            disabled={disabled}
            video={video}
            onSave={async (values) => {
              try {
                await updateVideo({ ...values, id: video.id });
              } catch (err) {
                // noop
              }
            }}
          />
        </React.Fragment>
      ))}

      {empty && <Text>No Videos</Text>}
    </View>
  );
}

const styles = StyleSheet.create({});

export default VideoList;
